import { PDFTitle } from "../../export-pdf/components/title";
import { Text } from "@react-pdf/renderer";
import { useTheme } from "@mui/material";
import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";

export const PDFWhatsIncluded = ({
  title,
  description,
}: {
  title?: string;
  description: string;
}) => {
  const { typographyStyle } = useAnalysisPDFStyles();
  const { palette } = useTheme();

  return (
    <>
      <PDFTitle title={title} />,
      <Text
        style={{
          ...typographyStyle.body1,
          color: palette.common.black,
          textAlign: "left",
          lineHeight: 1.2,
          fontSize: 10,
        }}
      >
        {description}
      </Text>
    </>
  );
};
